import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {AuthService} from '../../core/services/auth.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-google-signin',
  templateUrl: './google-signin.component.html',
  imports: [MatButtonModule,MatIconModule],
  styleUrls: ['./google-signin.component.scss']
})
export class GoogleSignInComponent implements OnInit {

  @Output() googleLoginSuccess = new EventEmitter<string>();

  constructor(private authService: AuthService) {
  }

  ngOnInit(): void {
  }

  initiateGoogleLogin(): void {
    window.location.href = environment.googleLoginUrl;
  }

}
